import React from "react";
import { ToggleButton, Wrapper, WrapperBundleGroup, WrapperBundleGroupLeft, WrapperBundleGroupRight, WrapperTitle, WrapperToggle } from "./bundle_group.style";
import BundleItem from "./bundle_item/bundle_item.container";
export default function BundleGroupUI(_a) {
    var itemsCount = _a.itemsCount, leftBundle = _a.leftBundle, rightBundle = _a.rightBundle, isMinishop = _a.isMinishop, currentItemID = _a.currentItemID, isClosed = _a.isClosed, onClickToggleButton = _a.onClickToggleButton;
    return (React.createElement(Wrapper, null,
        React.createElement(WrapperTitle, null,
            "\uAD6C\uB9E4\uC635\uC158(",
            itemsCount,
            ")"),
        React.createElement(WrapperBundleGroup, null,
            React.createElement(WrapperBundleGroupLeft, null, leftBundle === null || leftBundle === void 0 ? void 0 : leftBundle.map(function (bundle_item, i) { return (React.createElement(BundleItem, { key: i, bundle_item: bundle_item, isMinishop: isMinishop, currentItemID: currentItemID })); })),
            React.createElement(WrapperBundleGroupRight, null, rightBundle === null || rightBundle === void 0 ? void 0 : rightBundle.map(function (bundle_item, i) { return (React.createElement(BundleItem, { key: i, bundle_item: bundle_item, isMinishop: isMinishop, currentItemID: currentItemID })); }))),
        React.createElement(WrapperToggle, null, (itemsCount > 10) && (isClosed
            ? React.createElement(ToggleButton, { onClick: onClickToggleButton },
                "\uC5F4\uAE30  ",
                React.createElement("i", { className: 'icon-angle-down' }))
            : React.createElement(ToggleButton, { onClick: onClickToggleButton },
                "\uB2EB\uAE30  ",
                React.createElement("i", { className: 'icon-angle-up' }))))));
}



//////////////////
// WEBPACK FOOTER
// ./src/detail/components/tab/bundle_group/bundle_group.presenter.tsx
// module id = 268
// module chunks = 0